var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.LfBlueTitleComponent, { attrs: { title: _setup.texts.title } }),
      _c(
        "div",
        { staticClass: "step-wizard-container" },
        [
          _c("h2", { staticClass: "step-title" }, [
            _vm._v(" " + _vm._s(_setup.texts.caption)),
          ]),
          _c("div", { staticClass: "step-instructions" }, [
            _vm._v(" " + _vm._s(_setup.texts.body) + " "),
          ]),
          _c(_setup.TemplateSelectorTreeComponent, {
            staticClass: "invoices-template-selector-container",
            attrs: { idEntityType: _vm.model.templateEntityTypeId },
            on: { templateSelected: _setup.onTemplateSelected },
          }),
          _c(
            "div",
            { staticClass: "dialog-actions-container" },
            [
              _c(_setup.LfActionsBarComponent, {
                staticClass: "action-buttons",
                attrs: { buttons: _setup.buttons, showKebabMenu: false },
                on: { "execute-action": _setup.onExecuteAction },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }